import * as React from 'react';
import styled from 'styled-components';

import { Popover } from '@creditornot/cb-popover';

import { FilterTag } from './FilterTag';
import { PopoverContent } from './PopoverContent';

const StyledFilterTag = styled(FilterTag)`
  &:hover {
    cursor: pointer;
  }
`;

type Props = {
  label: string;
  removePopoverContent?: string;
  children?: React.ReactNode;
  popoverContent: React.ReactNode;
  onRemoveClick: React.MouseEventHandler<HTMLButtonElement>;
  size?: React.ComponentProps<typeof FilterTag>['size'];
  open?: boolean | undefined;
  onOpenChange?: ((open: boolean) => void) | undefined;
};

export const ClickableFilterTag: React.FC<Props> = ({
  label,
  removePopoverContent,
  children,
  popoverContent,
  open,
  onRemoveClick,
  onOpenChange,
  size,
}) => {
  return (
    <Popover
      placement="bottom-start"
      offset={4}
      openOnClick={true}
      openOnHover={false}
      renderArrow={false}
      open={open}
      onOpenChange={onOpenChange}
      hideWhenReferenceNotInViewport={false}
      content={<PopoverContent>{popoverContent}</PopoverContent>}
    >
      {({ refProps }) => (
        <div {...refProps} style={{ display: 'flex' }}>
          <StyledFilterTag
            label={label}
            removePopoverContent={removePopoverContent}
            onRemoveClick={onRemoveClick}
            size={size}
          >
            {children}
          </StyledFilterTag>
        </div>
      )}
    </Popover>
  );
};
